import { ListSubheader, ListSubheaderProps, Typography } from "@mui/material";
import type { JSX } from "react";

/**
 * List Subheader to separate List Items into groups
 */
export const SrSelectSubheader = ({ children, sx }: ListSubheaderProps): JSX.Element => (
  <ListSubheader
    disableGutters
    disableSticky
    sx={[
      {
        px: 2,
        py: 0.5,
        background: "unset",
        "&:first-child": {
          mt: 1,
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <Typography variant="h5" color="on.surfaceDim">
      {children}
    </Typography>
  </ListSubheader>
);

SrSelectSubheader.displayName = "SrSelectSubheader";
